import React, { useState, useEffect } from 'react';
import '../../styles/modals/StudentInfoModal.css';
import { ReactComponent as DeleteContentIcon } from '../../assets/svg/DeleteContentIcon.svg';
import { ReactComponent as AngleUp } from '../../assets/svg/AngleUp.svg';
import { ReactComponent as OptionRemove } from '../../assets/svg/DeleteContent.svg';

function SingleQuestion({
	question,
	questions,
	setQuestions,
	index,
	questionsTitleError,
	optionsTitleError,
	sameOptionsError,
}: {
	question: any;
	questions: any;
	setQuestions: any;
	index: number;
	questionsTitleError: any;
	optionsTitleError: any;
	sameOptionsError: any;
}) {
	const [showQuestion, setShowQuestion] = useState(true);
	const [sameOptions, setSameOptions] = useState(false);

	const _removeValue = (arr: any[], x: any) => {
		arr.splice(x, 1);
		return arr;
	};

	const handleAddOption = (index: number) => {
		let newList = [...questions];
		let element = newList[index];
		element.answers = [
			...element?.answers,
			{
				text: '',
				order: element?.answers?.length + 1,
			},
		];
		setQuestions(newList);
	};
	const handleOptionRemove = (index: number, Oindex: number) => {
		let newList = [...questions];
		let element = newList[index];
		element.answers = _removeValue(element.answers, Oindex);
		element.answers = element.answers?.map((answer: any, index: number) => {
			answer.order = index + 1;
			return answer;
		});
		setQuestions(newList);
	};
	const handleAnswerChange = (e: any, index: number, Oindex: number) => {
		let newList = [...questions];
		let element = newList[index];
		element.answers.splice(Oindex, 1, { text: e.target.value, order: Oindex + 1 });
		setQuestions(newList);
		if (checkIfDuplicateExists(element.answers)) {
			setSameOptions(true);
		} else setSameOptions(false);
	};
	const handleQuestionTitleChange = (e: any, index: number) => {
		let newList = [...questions];
		let element = newList[index];
		element.text = e.target.value;
		setQuestions(newList);
	};

	const handleQuestionRemove = (index: number) => {
		let newList = [...questions];
		newList = _removeValue(newList, index);
		let newReorderList = newList.map((item, index) => {
			return { ...item, order: index + 1 };
		});
		setQuestions(newReorderList);
	};

	const checkIfDuplicateExists = (arr: any) => {
		var newList = arr.map((item: any) => {
			return item.text;
		});
		return new Set(newList).size !== newList.length;
	};

	const handleCorrectAnswer = (Oindex: number) => {
		let newList = [...questions];
		let element = newList[index];
		element.correctAnswerIndex = Oindex;
		setQuestions(newList);
	};

	return (
		<div className='bg-lightBG rounded-xl p-4  border border-lightBG hover:border-primaryViolet' key={index} id={`question${index}`}>
			<div className=' '>
				<div
					className=' flex flex-row justify-between items-center '
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
					}}
				>
					<p className='text-primaryViolet font-semibold text-base text-left flex-1'>
						Question {question.order} {!showQuestion ? ': ' + question.text : ''}
					</p>

					<div className='flex flex-row pointer justify-between items-center' onClick={() => handleQuestionRemove(index)}>
						<p className='text-redError font-semibold text-lg mr-3'>Delete</p>
						<DeleteContentIcon fill='#FF747F' />
					</div>

					<button
						className={`flex items-center justify-center min-w-[55px] h-[55px] rounded-full ${showQuestion ? 'bg-white ' : 'bg-primaryViolet'} ml-[35px] cursor-pointer`}
						onClick={() => setShowQuestion((prev) => !prev)}
						style={{ transform: !showQuestion ? 'rotate(180deg)' : 'none' }}
					>
						<AngleUp color={showQuestion ? '#9392AD' : '#ffffff'} />
					</button>
				</div>
				{showQuestion && (
					<div className='my-3'>
						<input
							type='text'
							className={`w-full text-deepPurple  border py-3 border-x-0 border-t-0 border-b-deselectPurple ${
								questionsTitleError && question.text === '' ? 'border-b-redError placeholder-redError' : 'border-b-deselectPurple '
							} `}
							style={{ backgroundColor: 'transparent' }}
							placeholder={`${questionsTitleError && question.text === '' ? `Enter question here` + '*' : `Enter question here`}`}
							value={question.text}
							onChange={(e) => handleQuestionTitleChange(e, index)}
						/>
					</div>
				)}
			</div>

			{showQuestion && (
				<div className=''>
					<div className=''>
						{question?.answers?.map((answer: any, Oindex: number) => {
							return (
								<div className='flex my-3 flex-row items-center justify-between border border-deselectPurple hover:border-mudPurple rounded-xl py-3 px-4' key={Oindex}>
									<input
										type='text'
										className={`w-full text-deepPurple  border py-3 border-x-0 border-t-0 border-b-deselectPurple ${
											optionsTitleError && answer.text === '' ? 'border-b-redError placeholder-redError' : 'border-b-deselectPurple '
										}`}
										placeholder={`${optionsTitleError && answer.text === '' ? `answer-${Oindex + 1}` + '*' : `answer-${Oindex + 1}`}`}
										style={{ backgroundColor: 'transparent' }}
										value={answer?.text}
										onChange={(e) => handleAnswerChange(e, index, Oindex)}
									/>
									<div className={`flex flex-row items-center cursor-pointer mb-1`} onClick={() => handleCorrectAnswer(Oindex)}>
										<div className='border-[1.5px] border-primaryViolet rounded-full h-[14px] min-w-[14px] flex items-center justify-center'>
											{question.correctAnswerIndex === Oindex && <div className='rounded-full h-[8px] w-[8px] bg-primaryViolet'></div>}
										</div>
										<label className='text-primaryViolet text-[16px] font-medium ml-[13px] cursor-pointer not-selectable'>Correct Answer</label>
									</div>
									{question?.answers.length > 2 && (
										<div onClick={() => handleOptionRemove(index, Oindex)} className='pointer' data-tip={'Delete option'} data-for='survey-option-remove'>
											<OptionRemove fill='#FFA28D' />
										</div>
									)}
								</div>
							);
						})}
						<div className='mt-2'>
							<p className={`text-[#FF747F] font-medium text-[14px] text-center ${sameOptions && sameOptionsError ? '' : 'opacity-0'}`}>* Options must differ</p>
						</div>
						<div
							className='bg-lightBG border border-primaryViolet flex items-center justify-center pointer rounded-xl py-3 w-full font-semibold text-base text-primaryViolet'
							onClick={() => handleAddOption(index)}
						>
							Add answer
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default SingleQuestion;
